import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OrdemServico } from 'src/app/classes/OrdemServico';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-observacao-ordem-servico',
  templateUrl: './observacao-ordem-servico.component.html',
  styleUrls: ['./observacao-ordem-servico.component.scss']
})
export class ObservacaoOrdemServicoComponent implements OnInit {

  @Input() ordemServico: OrdemServico;
  @Output() OrdemServicoChangeEvento = new EventEmitter<OrdemServico>();
  permissaoEditarOS: boolean = false;
  constructor(private storageService: StorageService) {
    var usuario = this.storageService.getUsuario();
    this.permissaoEditarOS = usuario.PermissaoUsuario.EditarOS;
  }

  ngOnInit() {
  }

  osTimeout: any;
  ordemServicoChange() {
    console.log('change')
    if (this.osTimeout)
      clearTimeout(this.osTimeout);
    this.osTimeout = setTimeout(() => {
      this.OrdemServicoChangeEvento.emit(this.ordemServico)
    }, 500);
  }

}
